(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* Mobile menu */
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-menu-toggle]');
    if (!toggle) return;
    const header = toggle.closest('[data-header]');
    const open = header.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(open));
  });

  /* Cart drawer */
  const drawer = () => document.querySelector('[data-cart-drawer]');

  const openDrawer = () => {
    const el = drawer();
    if (el && !el.open) el.showModal();
  };

  const updateCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  };

  const refreshCart = async () => {
    const response = await fetch(`${root}?sections=cart-drawer`);
    const sections = await response.json();
    const html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    const fresh = html.querySelector('[data-cart-drawer-content]');
    const current = document.querySelector('[data-cart-drawer-content]');
    if (fresh && current) current.replaceWith(fresh);
    const cart = await (await fetch(`${root}cart.js`)).json();
    updateCount(cart.item_count);
    if (document.querySelector('[data-cart-page]')) window.location.reload();
  };

  const addItems = async (items) => {
    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items }),
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Error');
    await refreshCart();
    openDrawer();
  };

  document.addEventListener('click', async (event) => {
    const opener = event.target.closest('[data-cart-open]');
    if (opener && drawer()) {
      event.preventDefault();
      openDrawer();
      return;
    }

    if (event.target.closest('[data-cart-close]')) {
      drawer()?.close();
      return;
    }

    const el = drawer();
    if (el && event.target === el) el.close();

    const change = event.target.closest('[data-line-change]');
    if (change) {
      change.disabled = true;
      await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(change.dataset.lineChange), quantity: Number(change.dataset.quantity) }),
      });
      await refreshCart();
      return;
    }

    const quickAdd = event.target.closest('[data-quick-add]');
    if (quickAdd) {
      quickAdd.disabled = true;
      try {
        await addItems([{ id: Number(quickAdd.dataset.quickAdd), quantity: 1 }]);
      } finally {
        quickAdd.disabled = false;
      }
    }
  });

  /* Product form */
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-product-form]');
    if (!form || !drawer()) return;
    event.preventDefault();

    const button = form.querySelector('[data-add-button]');
    const error = form.querySelector('[data-form-error]');
    const data = new FormData(form);
    const items = [{ id: Number(data.get('id')), quantity: Number(data.get('quantity') || 1) }];
    const upsell = form.querySelector('[data-upsell]');
    if (upsell && upsell.checked) items.push({ id: Number(upsell.value), quantity: 1 });

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    error.hidden = true;
    try {
      await addItems(items);
    } catch (e) {
      error.textContent = e.message;
      error.hidden = false;
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });

  document.addEventListener('click', (event) => {
    const step = event.target.closest('[data-quantity-step]');
    if (!step) return;
    const input = step.closest('[data-quantity]').querySelector('input');
    input.value = Math.max(1, Number(input.value) + Number(step.dataset.quantityStep));
  });

  /* Variant picker */
  document.addEventListener('change', async (event) => {
    if (!event.target.matches('[data-variant-option]')) return;
    const section = event.target.closest('[data-product-section]');
    const info = section.querySelector('[data-product-info]');
    const variants = JSON.parse(info.querySelector('[data-variants]').textContent);
    const selected = [...info.querySelectorAll('fieldset[data-option-position]')].map(
      (fieldset) => fieldset.querySelector('input:checked')?.value,
    );
    const variant = variants.find((v) => v.options.every((value, i) => value === selected[i]));
    if (!variant) return;

    const url = `${section.dataset.productUrl}?variant=${variant.id}`;
    window.history.replaceState({}, '', url);
    const response = await fetch(`${url}&section_id=${section.dataset.sectionId}`);
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const freshInfo = html.querySelector('[data-product-info]');
    if (freshInfo) info.replaceWith(freshInfo);
    const freshBar = html.querySelector('[data-sticky-buy]');
    const bar = section.querySelector('[data-sticky-buy]');
    if (freshBar && bar) {
      freshBar.hidden = bar.hidden;
      bar.replaceWith(freshBar);
    }
    delete section.dataset.stickyReady;
    initStickyBar(section);
    if (variant.featured_media) goToMedia(section, variant.featured_media.id);
  });

  /* Gallery */
  const setCurrent = (gallery, index) => {
    gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
      thumb.setAttribute('aria-current', String(Number(thumb.dataset.galleryThumb) === index));
    });
    const counter = gallery.querySelector('[data-gallery-current]');
    if (counter) counter.textContent = index + 1;
  };

  const goToIndex = (gallery, index) => {
    const track = gallery.querySelector('[data-gallery-track]');
    track.scrollTo({ left: track.clientWidth * index, behavior: 'smooth' });
    setCurrent(gallery, index);
  };

  const goToMedia = (section, mediaId) => {
    const gallery = section.querySelector('[data-gallery]');
    const slides = [...gallery.querySelectorAll('[data-media-id]')];
    const index = slides.findIndex((slide) => Number(slide.dataset.mediaId) === mediaId);
    if (index >= 0) goToIndex(gallery, index);
  };

  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    goToIndex(thumb.closest('[data-gallery]'), Number(thumb.dataset.galleryThumb));
  });

  const initGallery = (gallery) => {
    const track = gallery.querySelector('[data-gallery-track]');
    if (!track || track.dataset.ready) return;
    track.dataset.ready = 'true';
    const start = Number(gallery.dataset.start || 0);
    if (start > 0) {
      track.scrollLeft = track.clientWidth * start;
      setCurrent(gallery, start);
    }
    let timer;
    track.addEventListener(
      'scroll',
      () => {
        clearTimeout(timer);
        timer = setTimeout(() => setCurrent(gallery, Math.round(track.scrollLeft / track.clientWidth)), 80);
      },
      { passive: true },
    );
  };

  /* Review slider */
  document.addEventListener('click', (event) => {
    const arrow = event.target.closest('[data-slider-prev], [data-slider-next]');
    if (!arrow) return;
    const track = arrow.closest('[data-slider]').querySelector('[data-slider-track]');
    const card = track.firstElementChild;
    const distance = card ? card.getBoundingClientRect().width + 16 : track.clientWidth;
    track.scrollBy({ left: arrow.matches('[data-slider-next]') ? distance : -distance, behavior: 'smooth' });
  });

  /* Sticky add-to-cart bar */
  const initStickyBar = (section) => {
    const bar = () => section.querySelector('[data-sticky-buy]');
    const target = section.querySelector('[data-add-button]');
    if (!bar() || !target || section.dataset.stickyReady) return;
    section.dataset.stickyReady = 'true';
    new IntersectionObserver(([entry]) => {
      const el = bar();
      if (el) el.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
    }).observe(target);
  };

  /* Dispatch countdown (UK time, working days) */
  const tickDispatch = () => {
    document.querySelectorAll('[data-dispatch]').forEach((el) => {
      const cutoff = Number(el.dataset.cutoff || 14);
      const uk = new Date(new Date().toLocaleString('en-GB', { timeZone: 'Europe/London' }));
      const day = uk.getDay();
      const minutes = uk.getHours() * 60 + uk.getMinutes();
      if (day >= 1 && day <= 5 && minutes < cutoff * 60) {
        const left = cutoff * 60 - minutes;
        const h = Math.floor(left / 60);
        const m = left % 60;
        const label = h > 0 ? `${h}h ${String(m).padStart(2, '0')}m` : `${m} min`;
        el.innerHTML = el.dataset.today.replace('[time]', `<strong>${label}</strong>`);
      } else {
        el.textContent = el.dataset.next;
      }
      el.hidden = false;
    });
  };
  setInterval(tickDispatch, 30000);

  const init = () => {
    tickDispatch();
    document.querySelectorAll('[data-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-product-section]').forEach(initStickyBar);
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();


/* Rails (horizontal sliders), help bubble and product feature video. */
(() => {
  const initRail = (rail) => {
    if (rail.dataset.railReady) return;
    rail.dataset.railReady = 'true';
    const track = rail.querySelector('[data-rail-track]');
    const bar = rail.querySelector('[data-rail-progress]');
    const prev = rail.querySelector('[data-rail-prev]');
    const next = rail.querySelector('[data-rail-next]');
    if (!track) return;
    const step = () => {
      const first = track.children[0];
      return first ? first.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth * 0.8;
    };
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      if (bar) {
        const ratio = Math.max(track.clientWidth / track.scrollWidth, 0.1);
        bar.style.width = `${ratio * 100}%`;
        bar.style.transform = `translateX(${max > 0 ? (track.scrollLeft / max) * (100 / ratio - 100) : 0}%)`;
      }
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    };
    prev?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-help-toggle]');
    const help = document.querySelector('[data-help]');
    if (!help) return;
    if (toggle) {
      const panel = help.querySelector('.help__panel');
      const open = panel.hidden;
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      return;
    }
    if (!event.target.closest('[data-help]')) {
      const panel = help.querySelector('.help__panel');
      if (panel && !panel.hidden) {
        panel.hidden = true;
        help.querySelector('[data-help-toggle]')?.setAttribute('aria-expanded', 'false');
      }
    }
  });

  document.addEventListener('click', (event) => {
    const play = event.target.closest('[data-feature-play]');
    if (!play) return;
    const box = play.closest('[data-feature-video]');
    const video = box?.querySelector('video');
    if (!video) return;
    box.classList.add('is-playing');
    video.controls = true;
    video.play();
    video.addEventListener('pause', () => box.classList.remove('is-playing'), { once: true });
  });

  const init = () => document.querySelectorAll('[data-rail]').forEach(initRail);
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();


/* Mobile nav offset and gallery lightbox. */
(() => {
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-menu-toggle]')) return;
    const header = document.querySelector('[data-header]');
    if (header) header.style.setProperty('--nav-top', `${Math.round(header.getBoundingClientRect().bottom)}px`);
  });

  document.addEventListener('click', (event) => {
    const zoom = event.target.closest('[data-gallery-zoom]');
    const close = event.target.closest('[data-lightbox-close]');
    const box = document.querySelector('[data-lightbox]');
    if (!box) return;
    if (close || (event.target === box && box.open)) {
      box.close();
      return;
    }
    if (!zoom) return;
    const gallery = zoom.closest('[data-gallery]');
    const track = gallery.querySelector('[data-gallery-track]');
    const index = Math.round(track.scrollLeft / track.clientWidth);
    const slide = track.children[index];
    const img = box.querySelector('img');
    img.src = slide?.dataset.zoom || slide?.querySelector('img')?.currentSrc || '';
    img.alt = slide?.querySelector('img')?.alt || '';
    box.showModal();
  });
})();

/* Turntable finder: score each model against the chosen answers. */
(() => {
  const score = (finder) => {
    const wanted = [...finder.querySelectorAll('input[type="radio"]:checked')].map((input) => input.value).filter(Boolean);
    const cards = [...finder.querySelectorAll('[data-finder-card]')];
    let best = null;
    let bestScore = -Infinity;
    cards.forEach((card, index) => {
      const flags = (card.dataset.flags || '').split(/\s+/).filter(Boolean);
      let total = 0;
      wanted.forEach((flag) => {
        total += flags.includes(flag) ? 2 : -3;
      });
      total -= flags.filter((flag) => !wanted.includes(flag)).length * 0.5;
      total -= index * 0.01;
      if (total > bestScore) {
        bestScore = total;
        best = card;
      }
    });
    cards.forEach((card) => {
      card.hidden = card !== best;
    });
  };

  document.addEventListener('change', (event) => {
    const finder = event.target.closest('[data-finder]');
    if (finder && event.target.matches('input[type="radio"]')) score(finder);
  });

  const init = () => document.querySelectorAll('[data-finder]').forEach(score);
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
